export const getResponseKey = (random = 0) => String(new Date().getTime() + random);
